import tailwindConfig from '@/tailwind.config.js';
import resolveConfig from 'tailwindcss/resolveConfig.js';

export const twConfig = resolveConfig(tailwindConfig);

export const grayLine =
    'text-gray-800/40 before:rounded-full before:w-1 before:h-1 before:bg-gray-800/30 before:inline-block before:align-middle before:mb-0.5 before:mr-2 inline-block first:before:hidden';
export const checkbox =
    'peer/checkboxInput form-checkbox relative z-10 m-0 h-4 w-4 flex-shrink-0 cursor-pointer border border-gray-200 align-top text-brand-500 shadow-sm transition duration-100 ease-in-out checked:border-brand-500 focus:border-brand-300 focus:outline-none focus:ring-2 focus:ring-brand-200 focus:ring-opacity-50 focus:ring-offset-0 disabled:cursor-not-allowed disabled:opacity-50';
